import { useEffect } from "react";
import { useParams } from "react-router-dom";

const Archives = () => {
  const { id } = useParams(); // Get 'id' from the URL
  useEffect(() => {
    // Update localStorage
    const setShortenerTimestamp = () => {
      const lastCompletedTime = localStorage.getItem("shortenerTimestamp");
      if (lastCompletedTime) {
        const timeElapsed = Date.now() - parseInt(lastCompletedTime, 10);
        const remainingTime = 3 * 60 * 60 * 1000 - timeElapsed; // 3 hours
        if (!remainingTime > 0) {
      localStorage.setItem("shortenerTimestamp", Date.now().toString());};
    }else{
      localStorage.setItem("shortenerTimestamp", Date.now().toString());
    }
  };
  setShortenerTimestamp();
    // Redirect to showflix.shop after a short delay
 
    if (id) {
      window.location.href = `https://showflix.shop/archives/${id}`; // Redirect
    }

  }, []);

  return (
    <div style={{ textAlign: "center", marginTop: "20%" }}>
      <h2>Redirecting you to Showflix...</h2>
      <p>Please wait while we process your request.</p>
    </div>
  );
};

export default Archives;
